<template>
  <sweet-modal :title="$t('settings_COA') + ' - ' + (state === 'create' ? $t('settings_addClass') : $t('settings_editClass'))"
               blocking
               ref="modal"
               class="modal"
               v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-position="left">
      <el-form-item prop="dbCode">
        <el-input
            v-if="state !== 'create'"
            readonly
            :label="$t('settings_accountThink_GLAccounts_dbCode')"
            v-model="form.dbCode"></el-input>
      </el-form-item>
      <el-form-item prop="number">
        <el-input :label="$t('settings_accountThink_GLAccounts_accNo')" v-model="form.number"></el-input>
      </el-form-item>
      <el-form-item prop="type">
        <el-input
            readonly
            :label="$t('settings_accountThink_GLAccounts_(type)')"
            v-model="form.type"></el-input>
      </el-form-item>
      <el-form-item prop="name">
        <el-input :label="$t('settings_accountThink_GLAccounts_(class)')" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="setAs" :label="$t('settings_accountThink_GLAccounts_setAs')">
        <el-radio-group v-model="form.DRCRCode" size="small" disabled>
          <el-radio label="DR" border style="margin-right: 0;">DR</el-radio>
          <el-radio label="CR" border>CR</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button v-if="state === 'create'" @click="create('form')" type="primary">{{$t('general_add')}}</el-button>
        <el-button v-else @click="update('form')" type="primary">{{$t('general_update')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "COAAddClassModal",
  data() {
    return {
      state: 'create',
      form: {
        dbCode: null,
        // accNo: null,
        type: null,
        // class: null,
        DRCRCode: 'CR',
        // right form
        typeId: null,
        filePath: [],
        name: null,
        number: null
      },
      rules: {
        // dbCode: [
        //   { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change' }
        // ],
        // accNo: [
        //   { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change' }
        // ],
        // type: [
        //   { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change' }
        // ],
        name: [
          { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ]
      },
      params: null,
      type: null
    }
  },
  components: {
    SweetModal
  },
  methods: {
    openModal(state, params) {
      this.params = params
      if (params.node.data.entityType === 'type') {
        this.form.typeId = params.node.data.id
        this.type = params.node.data
        this.form.type = params.node.data.name
        this.form.filePath = params.node.data.filePath
        this.form.DRCRCode = params.node.data.DRCRCode
      }

      if (params.node.data.entityType === 'class') {
        this.form.typeId = params.node.data.typeId
        // get type object
        params.api.forEachNode((node, index) => {
          if (node.data.id === params.node.data.typeId && node.data.filePath.length === 1) {
            this.type = node.data
            this.form.type = node.data.name
            this.form.filePath = node.data.filePath
          }
        })
      }
      this.state = state
      this.$refs.modal.open()
    },
    openModalEdit(state, params) {
      this.params = params
      this.form.DRCRCode = params.node.data.DRCRCode
      this.form.dbCode = params.node.data.code
      this.form.typeId = params.node.data.typeId
      this.form.name = params.node.data.name
      this.form.number = params.node.data.number
      // get type object
      params.api.forEachNode((node, index) => {
        if (node.data.id === params.node.data.typeId && node.data.filePath.length === 1) {
          this.type = node.data
          this.form.type = node.data.name
          this.form.filePath = node.data.filePath
        }
      })
      this.state = state
      this.$refs.modal.open()
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            typeId: this.form.typeId,
            filePath: this.form.filePath,
            name: this.form.name,
            number: this.form.number
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/accountClass/create?companyId=${this.$route.query.companyId}`, payload)
              .then(response => {
                console.log('response', response.data);
                this.notification(this.$t('general_success'), this.$t('setting_classCreated'), "success");
                this.$emit('loadList', { entityType: response.data.entityType, id: response.data.id })
                loader.hide()
                this.$refs.modal.close()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }
      })
    },
    update(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            name: this.form.name,
            number: this.form.number
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/accountClass/update?classId=${this.params.node.data.id}`, payload)
              .then(response => {
                console.log('response', response.data);
                this.notification(this.$t('general_success'), this.$t('setting_classUpdated'), "success");
                this.$emit('loadList', { entityType: 'class', id: this.params.node.data.id })
                loader.hide()
                this.$refs.modal.close()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }
      })
    },
    close() {
      this.state = 'create'
      this.form.dbCode = null
      this.form.type = null
      this.form.DRCRCode = 'CR'
      this.form.typeId = null
      this.form.filePath = []
      this.form.name = null
      this.form.number = null
      this.params = null
      this.type = null
      this.$refs['form'].resetFields()
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  }
}
</script>

<style scoped>

</style>
